"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var View_1 = require("../../View");
var StackView_1 = require("../../StackView");
var Text_1 = require("../../Text");
var TAG_HEIGHT = '22px';
var TagText = styled_components_1.default(Text_1.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    line-height: ", ";\n\n    ", "\n"], ["\n    line-height: ", ";\n\n    ",
    "\n"])), TAG_HEIGHT, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n    "], ["\n        color: ", ";\n    "])), disabled ? theme.colorTextLight : theme.colorTextMain);
});
var TagCLose = styled_components_1.default(Text_1.Text).attrs({
    weight: Text_1.TEXT_WEIGHT.bold
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 9px;\n    cursor: default;\n    line-height: 1;\n    user-select: none;\n\n    ", "\n"], ["\n    font-size: 9px;\n    cursor: default;\n    line-height: 1;\n    user-select: none;\n\n    ",
    "\n"])), function (_a) {
    var disabled = _a.disabled, error = _a.error, theme = _a.theme;
    if (disabled) {
        return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                color: ", ";\n            "], ["\n                color: ", ";\n            "])), theme.colorControlIconDisabled);
    }
    if (error) {
        return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                color: ", ";\n            "], ["\n                color: ", ";\n            "])), theme.colorControlIconError);
    }
    return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            color: ", ";\n        "], ["\n            color: ", ";\n        "])), theme.colorControlIcon);
});
var Root = styled_components_1.default(View_1.View).attrs(function (_a) {
    var disabled = _a.disabled, error = _a.error;
    return ({
        spaceHorizontal: View_1.INDENT.s,
        align: View_1.VIEW_ALIGN.center,
        distribution: View_1.VIEW_DISTRIBUTION.fill,
        backgroundView: disabled
            ? View_1.VIEW_BG_VIEW.disabled
            : error
                ? View_1.VIEW_BG_VIEW.highlightError
                : View_1.VIEW_BG_VIEW.highlight
    });
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    max-width: 100%;\n"], ["\n    max-width: 100%;\n"])));
exports.Tag = function (_a) {
    var title = _a.title, onRemove = _a.onRemove, error = _a.error, disabled = _a.disabled, rest = __rest(_a, ["title", "onRemove", "error", "disabled"]);
    return (react_1.default.createElement(Root, { error: error, disabled: disabled, "data-selector-id": rest['data-selector-id'] || 'tag', size: { height: TAG_HEIGHT } },
        react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.s, distribution: StackView_1.STACK_DISTRIBUTION.firstFill, align: StackView_1.STACK_ALIGN.center, size: { width: '100%' } },
            react_1.default.createElement(TagText, { disabled: disabled, error: error, truncate: true, size: Text_1.TEXT_SIZE.s }, title),
            react_1.default.createElement(TagCLose, { "data-selector-id": 'close', error: error, disabled: disabled, onClick: function () {
                    if (!disabled) {
                        onRemove === null || onRemove === void 0 ? void 0 : onRemove();
                    }
                } }, "\u2715"))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=Tag.js.map